import { gsap } from 'gsap';

export default class FadeIn {
  constructor(element) {
    this.element = element;
  }

  init() {
	gsap.timeline()
	// .set(this.element, {
	// 	opacity: 0
	// })
	.from(this.element, {
			opacity: 0,
			y: this.element.dataset.fadeFrom,
			duration: 1.5
		})
  }
}

